import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import {Outlet, useNavigate} from "react-router-dom";
import AppHeader from "./components/AppHeader";
import AppSidebar from "./components/AppSidebar";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {useEffect, useState} from "react";
import {connect} from "trim-redux";
import clsx from "clsx";
import AppFooter from "./components/footer/AppFooter";
import ErrorPage from "../../pages/errors/ErrorPage";

function Layout({classes,user,isAuth,panel,front,error}) {
    const navigate = useNavigate();
    const redirect = localStorage.getItem('redirect');

    useEffect(() => {
        if (isAuth) {
            if(!user?.id_number){
                navigate('/user-info')
            }
            if(!!redirect){
                localStorage.removeItem('redirect');
                navigate(redirect)
            }
        }
    }, [user,isAuth ]);


    return (
        <React.Fragment>
            {
                !!error ?
                    <ErrorPage error={error}/>
                    :
                    <>
                        <CssBaseline />
                        <AppHeader panel={panel}/>
                        <main className={classes.layoutMain}>
                            {
                                !!panel &&
                                <AppSidebar/>
                            }

                            <div className={clsx(classes.layoutHolder,!!panel ? "panel-layout" : !!front ? 'front-layout' : 'normal-layout')}>
                                {

                                    front ?
                                        <Outlet/>
                                        :
                                        <Container maxWidth="lg" >
                                            <Outlet/>
                                        </Container>
                                }
                            </div>
                        </main>
                        {
                            !panel &&
                            <AppFooter />
                        }
                    </>
            }
        </React.Fragment>
    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    error: state.error,
});

export default withStyles(Styles)(connect(mapStateToProps)(Layout));
